import proxy from "api/proxy";

async function fetchCounts(sources) {
  const results = await Promise.all(
    sources.map((source) => proxy.searchCount(source.model, source.domain)),
  );
  const counts = {};
  sources.forEach((source, idx) => {
    const { data, error } = results[idx] || {};
    counts[source.id] = error ? null : data;
  });
  return counts;
}

export { fetchCounts };
